import colors from './colors';
const forms = {
    inputShadow: 'inset 0 2px 3px 0 rgba(0, 0, 0, 0.14)',
    inputPadding: '0.625rem 0.1875rem 0.625rem 1.25rem',
    fontWeight: 400,
    inputHeight: '3.125rem',
    inputBorder: `1px solid ${colors.grayL20}`,
    inputBorderRadius: 0,
    iconSize: '1.625rem',
    iconSpacing: '0.625rem',
    inputDisabledBackgroundColor: `${colors.grayL30}`,
    inputErrorOutlineColor: `${colors.yellow}`,
    switchColorOn: `${colors.primary}`,
    switchColorOff: `${colors.gray}`,
    switchCheckMarkDisplay: 'none',
    textareaHeight: '7.25rem',
};
export default forms;
//# sourceMappingURL=forms.js.map